<template>
  <div>
    <div class="header">
      <div class="menuContainer">
        <router-link to="/"> <img src="../../assets/img/logo.png" alt="" /></router-link>
      </div>
      <div class="userInfo fr">
        <!-- 汇率 -->
        <span>{{ $t("message.rate") }}:{{ rate }}</span>
        <!--        语言-->
        <span> {{ $t("message.language") }} :</span>
        <el-select v-model="value" @change="setLang" size="mini" style="margin-right: 20px">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <img src="../../assets/icon/chat.png" class="chat" @click="chat" />
        <img src="../../assets/img/user.png" alt="" />
        <!-- 包裹下拉菜单 hover -->
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            <!--            业务员-->
            {{ userInfo.realname
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logOut">{{
              $t("message.logOut")
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 往上 -->
    <el-backtop :bottom="70" :right="10">
      <div class="up">
        <i class="el-icon-arrow-up"></i>
      </div>
    </el-backtop>
    <!-- 往下 -->
    <div class="bottom" @click="toBottom">
      <i class="el-icon-arrow-down"></i>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time: "",
      isChat: location.host == "spain.rakumart.es" ? true : false,
      value: this.$i18n.locale,
      options: [
        {
          value: "zh",
          label: "中文",
        },
        {
          value: "ja",
          label: "日本語",
        },
      ],
      choose: 0,
    };
  },
  computed: {
    userInfo() {
      if (localStorage.getItem("japanUserRoleInfo")) {
        return JSON.parse(localStorage.getItem("japanUserRoleInfo"));
      } else {
        return {};
      }
    },
    rate() {
      return this.$store.state.rate
    }
  },
  created() {
    this.$store.dispatch("orderStatusMap");
    this.$store.dispatch("typeList");
    this.$store.dispatch("getProblemTypes");
    this.$store.dispatch("getExchangeRat");
    this.$store.dispatch("getAuthWorkGroupAdmin");
  },
  mounted() {
    // setInterval(() => {
    //   this.time = this.getCurrentDate(2);
    // }, 1000);
    // setTimeout(() => {
    //   this.$store.commit("setLeftMenu", this.menu[0].child_menus);
    // }, 300);
  },
  methods: {
    toBottom() {
      var osTop = 0
      let timer = setInterval(function () {
        var body = document.querySelector('body')
        var detailHeight = body.scrollHeight
        let ispeed = Math.floor(detailHeight / 5);
        osTop += ispeed
        window.scrollTo(0, osTop)
        if (osTop >= detailHeight) {
          clearInterval(timer);
        }
      }, 50);
    },
    // 下拉菜单
    handleCommand(command) {
      if (command == "logOut") {
        this.logOut();
      } else if (command == "password") {
        this.pswdDialogVisible = true;
      }
    },
    // 退出登录
    logOut() {
      this.$router.push("/login");
      localStorage.removeItem("access_token");
      localStorage.removeItem("userRoleInfo");
      localStorage.removeItem("menu");
      localStorage.removeItem("userAuth");
    },

    // 语言切换
    setLang() {
      this.$i18n.locale = this.value;
      localStorage.setItem('locale', this.value)
      // this.$router.go(0)
      this.$forceUpdate();
    },
    chat() {
      let japanUserRoleInfo = JSON.parse(localStorage.getItem('japanUserRoleInfo'))
      let token = localStorage.getItem('japan_access_token')
      let iTop = (window.screen.availHeight - 30 - 700) / 2;
      //获得窗口的水平位置
      let iLeft = (window.screen.availWidth - 10 - 1260) / 2;
      if (location.host.indexOf('.co.jp') !== -1) {
        window.open(
          `https://rakuchat.rakumart.com/admin_web/#/?id=JP${japanUserRoleInfo.id}&token=${token}`,
          japanUserRoleInfo,
          "height=700, width=1260, left=" +
          iLeft +
          ", top=" +
          iTop +
          ", toolbar=no, menubar=no, scrollbars=yes, resizable=no, location=no, status=no"
        );
      }


    },
    // 时区
    getLocalTime(i) {
      //参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
      if (typeof i !== "number") return;
      var d = new Date();
      //得到1970年一月一日到现在的秒数
      var len = d.getTime();
      //本地时间与GMT时间的时间偏移差
      var offset = d.getTimezoneOffset() * 60000;
      //得到现在的格林尼治时间
      var utcTime = len + offset;
      return new Date(utcTime + 3600000 * i);
    },
    // 获取时区
    getCurrentDate(i) {
      var time = "";
      var now = this.getLocalTime(i);
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      return (time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec);
    },
  },
};
</script>
<style lang='scss' scoped>
.header {
  //overflow: hidden;
  height: 50px;
  background: #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 1910px;

  h1 {
    margin-right: 100px;
    padding: 10px 0 0 20px;
    line-height: 40px;
    cursor: pointer;

    img {
      width: 154px;
      height: 40px;
    }
  }

  .menuContainer {
    display: flex;
    align-items: center;
    margin-left: 24px;

    img {
      height: 40px;
    }
  }

  .userInfo {
    font-size: 14px;
    height: 30px;
    margin: 0px 20px 0 0;
    line-height: 30px;

    img {
      height: 16px;
      margin-right: 10px;
      vertical-align: middle;
      cursor: pointer;
    }

    span {
      display: inline-block;
      margin: 0 10px 0 40px;
    }
  }
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 240px;
}

.language {
  display: inline-block;

  span {
    display: inline-block;
    width: 80px;
    margin: 0;
  }
}

.up {
  height: 100%;
  width: 100%;
  background-color: #b4272d;
  box-shadow: 0 0 6px rgba(0, 0, 0, .12);
  text-align: center;
  line-height: 40px;
  color: #fff;
  border-radius: 50%;
}

.bottom {
  height: 40px;
  width: 40px;
  background-color: #b4272d;
  box-shadow: 0 0 6px rgba(0, 0, 0, .12);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: fixed;
  z-index: 9999;
  right: 10px;
  bottom: 20px;
  cursor: pointer;

  i {
    font-size: 20px;
    color: #fff;
  }
}
</style>